module.exports = __webpack_public_path__ + "static/media/ordered-for-inactive.f3e21c77.svg";